import { render, staticRenderFns } from "./ContratoGrillaDetalle.vue?vue&type=template&id=01297a77&"
import script from "./ContratoGrillaDetalle.vue?vue&type=script&lang=ts&"
export * from "./ContratoGrillaDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./ContratoGrillaDetalle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports